appHost.actions.register({
    // #region Vars
    name: '288a.layouts.layout.edit',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Check
        if (!data.layout) {
            return this.Cancel();
        }
        // #endregion
        // #region Simple
        if (!utils.isArray(data.layout)) {
            this.layoutEditByName(data.layout, data, params);
        }
        // #endregion
        // #region Multi
        else {
            // #region Layouts
            let tLayouts = data.layout;
            // #endregion
            // #region Run
            if (!tLayouts || tLayouts.length === 0) {
                return this.Cancel();
            }
            else if (tLayouts.length === 1) {
                this.layoutEditByName(tLayouts[0], data, params);
            }
            else {
                var tData = {
                    data: {
                        layouts: tLayouts
                    },
                    onCommitFunc: (args) => {
                        if (args.selectedKey) {
                            this.layoutEditByName(args.selectedObject, data, params);
                        }
                    }
                };
                await this.$appHost.notification.showModal2("g-layout__designer-layoutselect", tData, { variant: "popup", closeOnKeyEsc: false, closeOnOutsideClick: false });
            }
            // #endregion
        }
        // #endregion
        return this.Ok();
    },
    // #endregion
    // #region Core
    methods: {
        async layoutEditByName(name, data, params) {
            // #region Args
            var tData = {
                objectKey: name,
                onCommitFunc: () => {
                    //Remove
                    this.$appHost.metadata.remove(name);
                    //Run
                    data.onCommitFunc(name);
                }
            };
            // #endregion
            await this.$appHost.notification.showModal2("g-layout__designer-rawedit", tData, { variant: "slide", position: "end", size: "large", closeOnKeyEsc: false, closeOnOutsideClick: false });
        },
    },
    // #endregion
});
export {};
